import { handleActions } from 'redux-actions';

import { ACTION_PREFIX, actionTypes } from './constants';
import { getActionOptions } from '../../../utils/reduxactionsutils';

export const initialState = {
  errorMessage: null,
  individualTrustee: {
    error: null,
  },
  trusteeAsCompanyValidationResult: {
    abn: null,
    isValidated: false,
    isEligible: false,
    message: null,
  },
  trusteeNames: null,
};

const reducer = handleActions(
  {
    [actionTypes.UPDATE_TRUSTEE_VALIDATION_RESULT]: (state, { payload }) => ({
      ...state,
      trusteeAsCompanyValidationResult: payload,
    }),
    [actionTypes.UPDATE_INDIVIDUAL_TRUSTEE]: (state, { payload }) => ({
      ...state,
      errorMessage: payload.message,
      trusteeAsCompanyValidationResult: initialState.trusteeAsCompanyValidationResult,
      individualTrustee: Object.assign({}, state.individualTrustee, {
        error: payload.message,
      }),
    }),
    [actionTypes.UPDATE_TRUSTEE_NAMES]: (state, { payload }) => ({
      ...state,
      trusteeNames: payload.trusteeNames,
    }),
    [actionTypes.RESET_TRUSTEE_VALIDATION_RESULT]: (state) => ({
      ...state,
      trusteeAsCompanyValidationResult: initialState.trusteeAsCompanyValidationResult,
    }),
  },
  initialState,
  getActionOptions(ACTION_PREFIX),
);

export default reducer;
